export const ACCOUNT_NUMBER = 'liveperson-account-number';
export const CSTATUS = 'liveperson-cstatus';
export const CTYPE = 'liveperson-ctype';
export const TAG_SECTION = 'liveperson-tag-section';
